// dayjs is loaded once globally and extended with the plugins the codebase uses.
// Backend Day 20.3 swapped moment → dayjs with zero plugin usage; frontend uses 4:
//   - duration:        date-time-helper.jsx getDurationBetweenTwoDates()
//   - relativeTime:    notifications + my-reports list-item .fromNow()
//   - utc:             analytics Table + analytics-main moment.utc(...)
//   - localizedFormat: localized format tokens LT/LL/LLL/llll used by
//       titlePageReportPreview (LT), signup (LL), subscriptions-invoice-details
//       + alertModal (llll), form-dispatch-list (LLL). moment shipped these
//       tokens by default; without this plugin dayjs prints the literal token
//       string (e.g. "LT") — see the report-preview "Invalid Date/Time" ticket.
// Italian locale (`it`) is loaded for one .locale("it").fromNow() call in
// notificationsDialog.js — kept identical to the prior moment behavior.
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/it';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(localizedFormat);

export default dayjs;
